/// <amd-module name="Artifacts/Root/components/DeprecateModal" />
import { CommandPanel } from "Artifacts/Root/components/CommandPanel";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { RootModule } from "Artifacts/Root/redux/Module";
import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { connect } from "react-redux";
import { ObservableValue } from "VSS/Core/Observable";
import { TextField } from "VSSUI/TextField";

export interface IDeprecateModalProps {
  packages?: IPackageVersionIdentity[];
  onDismiss: () => void;
  onDeprecate: (message: string) => void;
}

interface IMapStateToProps {
  componentState: ComponentState;
}

export const DeprecateModalId = "DeprecateModal";

const DeprecateModal: React.FC<IDeprecateModalProps & IMapStateToProps> = ({
  packages,
  onDismiss,
  onDeprecate,
  componentState,
}) => {
  const deprecationMessageObservable = new ObservableValue<string>("");
  return (
    <CommandPanel
      title={Res.DeprecateDialogTitle}
      description={Res.DeprecatePackageDialogInfo}
      fwLinkId={"2047640"}
      packages={packages}
      onDismiss={onDismiss}
      onSubmit={() => onDeprecate(deprecationMessageObservable.value)}
      submitButtonComponentState={componentState}
      submitButtonText={Res.SaveDeprecationMessageCommandButton}
    >
      <TextField
        className="deprecate-message-textfield"
        ariaLabel={Res.DeprecateMessageAriaLabel}
        placeholder={Res.DeprecationMessagePlaceholder}
        value={deprecationMessageObservable}
        onChange={(e, newValue) => {
          deprecationMessageObservable.value = newValue;
        }}
        multiline
        rows={4}
      />
    </CommandPanel>
  );
};

const mapStateToProps = (state: IRootModuleState): IMapStateToProps => {
  const rootState = state.rootState;
  return {
    componentState: rootState.deprecateCommandState,
  };
};

const ConnectedDeprecateModal = connectDynamicModules(connect(mapStateToProps)(DeprecateModal), [
  RootModule,
]);

registerModal(DeprecateModalId, ConnectedDeprecateModal);

export { DeprecateModal };
